export default "__VITE_ASSET__CE6xhP0B__"